"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSymbolLibrary = parseSymbolLibrary;
exports.parseSymbolLibraryWithFootprints = parseSymbolLibraryWithFootprints;
const Util_1 = require("../Util");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const layers_1 = require("./layers");
const v6schema_1 = require("./schematic/v6schema");
const kicad_file_type_1 = require("./kicad-file-type");
const board_1 = require("./board");
const NodeParser_1 = require("../common/NodeParser");
const KicadComponentPadCount_1 = require("./KicadComponentPadCount");
function parseSymbolLibrary(filename, contents, parser = new NodeParser_1.SExpressionFileParser()) {
    const layerSelector = new layers_1.KicadSchLayerSelector();
    const model = {
        modelType: 'library',
        name: filename,
        layerSets: {
            [layers_1.KICAD_SCH_LAYERSET]: {
                type: 'layerSet',
                layerSetType: 'schematic',
                id: layers_1.KICAD_SCH_LAYERSET,
                layers: layerSelector.getLayers(),
            },
        },
        components: {},
        metadata: {},
        warnings: [],
    };
    const tree = parser.parseFile(filename, contents);
    (0, v6schema_1.setLayerSelector)(layerSelector);
    (0, v6schema_1.parseComponents)(model, tree, new sigma_engine_shared_1.NetRefCtx());
    tree.nodes.forEach((node) => {
        switch (node.name) {
            case 'generator':
            case 'version': {
                model.metadata[node.name] = node.values[0];
                break;
            }
        }
    });
    (0, Util_1.dedupeWarnings)(model);
    (0, v6schema_1.setLayerSelector)(undefined);
    return model;
}
function parseSymbolLibraryWithFootprints(files, parser = new NodeParser_1.SExpressionFileParser()) {
    const symbolFile = files.find((f) => f.name.endsWith(kicad_file_type_1.KicadFileType.KicadSymbol));
    if (!symbolFile) {
        throw new Error('No symbol file found');
    }
    const schLayerSelector = new layers_1.KicadSchLayerSelector();
    const brdLayerSelector = new layers_1.KicadPcbLayerSelector();
    const model = {
        modelType: 'library',
        name: symbolFile.name,
        layerSets: {
            [layers_1.KICAD_SCH_LAYERSET]: {
                type: 'layerSet',
                layerSetType: 'schematic',
                id: layers_1.KICAD_SCH_LAYERSET,
                layers: schLayerSelector.getLayers(),
            },
            [layers_1.KICAD_BRD_LAYERSET]: {
                type: 'layerSet',
                layerSetType: 'pcb',
                id: layers_1.KICAD_BRD_LAYERSET,
                layers: brdLayerSelector.getLayers(),
            },
        },
        components: {},
        metadata: {},
        warnings: [],
    };
    const tree = parser.parseFile(symbolFile.name, symbolFile.contents);
    (0, v6schema_1.setLayerSelector)(schLayerSelector);
    (0, v6schema_1.parseComponents)(model, tree, new sigma_engine_shared_1.NetRefCtx());
    tree.nodes.forEach((node) => {
        switch (node.name) {
            case 'generator':
            case 'version': {
                model.metadata[node.name] = node.values[0];
                break;
            }
        }
    });
    const footprintFiles = files
        .filter((f) => f.name.endsWith(kicad_file_type_1.KicadFileType.KicadModule))
        .sort((a, b) => a.name.localeCompare(b.name));
    const parsedFootprints = {};
    for (const footprintFile of footprintFiles) {
        const tree = parser.parseFile(footprintFile.name, footprintFile.contents);
        (0, board_1.setBoardLayerSelector)(brdLayerSelector);
        const { footprint } = (0, board_1.readModule)(undefined, model, tree, new Set(brdLayerSelector.getLayers().map((l) => l.id)));
        parsedFootprints[footprintFile.name] = footprint;
        footprint.ref = footprintFile.name
            .split(/[/\\]/)
            .pop()
            .substr(0, footprintFile.name.length - kicad_file_type_1.KicadFileType.KicadModule.length);
    }
    for (const component of Object.values(model.components)) {
        component.metadata = component.metadata ?? {};
        component.metadata.filename = symbolFile.name;
        if (typeof component.metadata.ki_fp_filters === 'string') {
            const filters = component.metadata.ki_fp_filters.split(' ');
            for (const filter of filters) {
                const fpFiles = footprintFiles.find((f) => f.name.endsWith(filter + kicad_file_type_1.KicadFileType.KicadModule));
                if (fpFiles) {
                    component.footprints.push(parsedFootprints[fpFiles.name]);
                }
            }
        }
        else {
            for (const parsed of Object.values(parsedFootprints)) {
                component.footprints.push(parsed);
            }
        }
        component.numPads = KicadComponentPadCount_1.KicadComponentPadCount.deriveNumPads(component.footprints);
    }
    (0, Util_1.dedupeWarnings)(model);
    (0, v6schema_1.setLayerSelector)(undefined);
    return model;
}
//# sourceMappingURL=symbol_lib.js.map